import React from "react";
import MaskedInput from "react-text-mask";
import "./TextInput.css";

class CPFInput extends React.Component {
	//const { label } = props;
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.CPFInput.inputElement.focus();
	}

	onFocusHadler = (e) => {
		if (this.input && this.input.inputElement) {
			this.input.inputElement.select();
		}
	};

	value() {
		return this.CPFInput.inputElement.value;
	}
	render() {
		return (
			<MaskedInput
				ref={(input) => {
					this.CPFInput = input;
				}}
				mask={[/\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/]}
				className="ha-tf"
				id="CPFInput"
				onBlur={this.props.onBlur}
				onChange={this.props.onChange}
				value={this.props.value}
				type="tel"
				placeholder="___.___.___-__"
				autoComplete="off"
			/>
		);
	}
}

export default CPFInput;
